<script setup lang="ts">
import { getColors } from 'theme-colors';

const platform = useState('platform')
platform.value = useSiteConfig().platform

function generateColor(name: string, color: string) {
  return Object.entries(getColors(color))
      .map(([key, value]) => `--ui-color-${name}-${key}: ${value};`)
      .join('\n  ')
}

const root = computed(() => {
  return `@layer theme {
    :root {
    ${Object.entries(platform.value?.settings?.colors ?? {}).map(([key, value]) => generateColor(key, value)).join('\n  ')}
    }

    :root, .light {
    ${Object.entries(platform.value?.settings?.colors ?? {}).map(([key, value]) => `--ui-${key}: var(--ui-color-${key}-500);`).join('\n  ')}
    }
    .dark {
    ${Object.entries(platform.value?.settings?.colors ?? {}).map(([key, value]) => `--ui-${key}: var(--ui-color-${key}-400);`).join('\n  ')}
    }
  }`
})

const font = computed(() => {
  return `:root {
    --font-sans: '${platform.value.settings?.font}', sans-serif;
  }`
})


if (platform.value) {
  useHead({
    style: [{
      innerHTML: () => root?.value ?? '' ,
      tagPriority: 'critical',
      id: 'ligilab-colors'
    }]
  })

  if (platform.value.settings?.font) {
    useHead({
      style: [{
        innerHTML: () => font?.value ?? '',
        tagPriority: 'critical',
        id: 'ligilab-font'
      }]
    })
  }
}
</script>

<template>
  <slot />
</template>